import React, { useRef, useEffect } from 'react';
import { Monitor, Smartphone, ChevronDown } from 'lucide-react';

const ViewModeSelector = ({ isDesktopView, onViewChange, isOpen, onToggle }) => {
  const dropdownRef = useRef(null);
  
  // Handle clicks outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onToggle(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen, onToggle]);
  
  return (
    <div className="relative mr-2" ref={dropdownRef}>
      <button
        className="flex items-center space-x-1 bg-neutral-50 dark:bg-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-600 rounded p-1.5 text-ui-text-primary"
        onClick={() => onToggle(!isOpen)}
        title={isDesktopView ? 'Desktop View' : 'Mobile View'}
      >
        {isDesktopView ? <Monitor size={16} /> : <Smartphone size={16} />}
        <ChevronDown size={12} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 top-full mt-1 bg-white dark:bg-neutral-800 rounded-md shadow-lg z-50 py-1 border border-neutral-200 dark:border-neutral-700">
          <button
            className={`w-full flex items-center justify-center p-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors ${
              isDesktopView ? 'text-brand-primary' : 'text-ui-text-primary'
            }`}
            onClick={() => {
              onViewChange(true);
              onToggle(false);
            }}
            title="Desktop View"
          >
            <Monitor size={16} />
          </button>
          <button
            className={`w-full flex items-center justify-center p-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors ${
              !isDesktopView ? 'text-brand-primary' : 'text-ui-text-primary'
            }`}
            onClick={() => {
              onViewChange(false);
              onToggle(false);
            }}
            title="Mobile View"
          >
            <Smartphone size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewModeSelector; 